import { createContext } from 'react';

export interface ITheme {
    palette: {
        primary: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        secondary: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        error: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        success: {
            main: string;
            light: string;
            dark: string;
            contrastText: string;
        }
        divider: string;
    },
    background: {
        default: string;
        paper: string;
        panel: string;
        card: string;
    },
    text: {
        primary: string;
        secondary: string;
        disabled: string;
        muted: string;
    },
    colors: {
        green: {
            g1: string;
            g2: string;
            g3: string;
        },
        accent: {
            korea: string;
            egypt: string;
        },
        line: string;
    },
    borderRadius: {
        r1: string;
        r2: string;
    },
    shadow: {
        shadow1: string;
    }
}

export type TBreakpoint = {
    xs: boolean;
    sm: boolean;
    md: boolean;
    lg: boolean;
    xl: boolean;
}

interface IThemeContext {
    theme: ITheme;
    breakpoint: TBreakpoint;
}

export const ThemeContext = createContext<IThemeContext | undefined>(undefined);